import React from "react";
import { injectIntl } from "react-intl";
import config from "./ModuleDefinition";
import EntityForm from "../EntityForm/EntityForm";
import { entityToFormValuesMapper } from "../../Common/utils";
import { withPropertyData } from "../../../../components/property-admin-data-provider";

function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });
  return { ...formValues };
}

class ConditionsForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  getFields(fields) {
    return fields && fields.form;
  }

  handleSubmit = ({ formValues }) => {
    console.log("submitted ");
    //TODO: handle case when there's an original entity
    //TODO: this could be handled in a generic way.
    const entity = {
      ...formValues,
    };
    if (
      config.hasOwnProperty("translation") &&
      config.translation.hasOwnProperty("entityProperty")
    ) {
      delete entity[config.translation.fieldName];
      const translationField = config.translation.fieldName;
      const translationValues =
        (formValues.hasOwnProperty(translationField) && formValues[translationField]) || [];
      entity[config.translation.entityProperty] = translationValues.map(translation => {
        return {
          locale: translation.locale,
          name: translation.name,
          description: translation.description,
        };
      });
    }

    if (formValues.id) {
      entity.id = formValues.id;
    }

    entity.code = formValues.ticker;

    entity.earlyCharge = parseFloat(formValues.earlyCharge);
    entity.minimumCharge = parseFloat(formValues.minimumCharge);

    if (formValues.translations) {
      formValues.translations.forEach((translation, index) => {
        if (entity.translations[index]) {
          entity.translations[index].text = "text";
          entity.translations[index].html = "html";
        }
      });

      entity.name = formValues.translations[0].name;
      entity.type = entity.name;
    }

    delete entity.undefined;

    this.props.onSubmitEntity({ entity });
  };

  render() {
    const {
      name,
      validation,
      fields,
      renderers,
      translation,
      entities,
      locale,
    } = this.props.config;
    const {
      locales,
      entity,
      entityError,
      entityResult,
      entityName,
      loading,
      getListPath,
      relatedEntities,
    } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <EntityForm
        loading={loading}
        name={name}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        entityResult={entityResult}
        entityName={entityName}
        getListPath={getListPath}
        entityToFormValuesMapper={customEntityToFormValuesMapper}
        relatedEntities={relatedEntities}
        locale={locale}
      />
    );
  }
}

ConditionsForm.propTypes = {};

ConditionsForm.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
  entity: {
    propertyTicker: "demo_raul",
    ticker: "nadal",
    validFrom: "2018-12-15",
    validTo: "2018-12-31",
    ordering: "2",
    configurations: [
      {
        maxRelease: { duration: "5", chronoUnit: "DAYS" },
        minRelease: { duration: "1", chronoUnit: "DAYS" },
        type: "FIX_AMOUNT",
        penalty: "50.5",
        cancelOnline: false,
      },
      {
        maxRelease: { duration: "10", chronoUnit: "DAYS" },
        minRelease: { duration: "5", chronoUnit: "DAYS" },
        type: "PERCENTAGE",
        penalty: "50.5",
        cancelOnline: false,
      },
      {
        maxRelease: { duration: "15", chronoUnit: "DAYS" },
        minRelease: { duration: "10", chronoUnit: "DAYS" },
        type: "CHARGE_FIRST_NIGHT",
        penalty: "50.5",
        cancelOnline: true,
      },
    ],
  },
  getListPath: function getListPath({ hotelTicker, entityName }) {
    return `/${hotelTicker}/${entityName}/`;
  },
};

export default injectIntl(withPropertyData(ConditionsForm));
